"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CareerSiteHeaderFooterDataProvider = (function () {
    function CareerSiteHeaderFooterDataProvider() {
    }
    CareerSiteHeaderFooterDataProvider.prototype.mapHeaderFooterFromCareerSite = function (careerSiteData) {
        var defaultValues = {
            header: {
                isAdvanced: false,
                html: '',
                color: '',
                imagePath: '',
                imageAlt: ''
            },
            footer: {
                isAdvanced: false,
                html: '',
                color: '',
                imagePath: '',
                imageAlt: ''
            },
            settings: {
                allowedLanguages: [],
                signInPath: "",
                signOutPath: "",
                createProfilePath: "",
                myProfilePath: "",
                showToolbar: true,
                currentLanguage: {
                    cultureId: 1,
                    cultureName: "en-US",
                    isRightToLeft: false
                },
                mapsApiKey: "",
                mapsIsPremium: false,
                allowSEO: false,
                jobPostingSEOLogoPath: ""
            },
            searchBanner: {
                bannerImagePath: [],
                bannerHtml: ""
            },
            companyInformationHtml: "",
            jobDetailsBannerImagePath: ""
        };
        var newValues = Object.assign(defaultValues, careerSiteData);
        newValues.settings = Object.assign(newValues.settings, careerSiteData);
        var languages = [];
        for (var _i = 0, _a = newValues.settings.allowedLanguages; _i < _a.length; _i++) {
            var item = _a[_i];
            languages.push({ label: item.displayTitle, value: item.cultureId.toString() });
        }
        newValues.settings.allowedLanguages = languages;
        var defaultMapsApiValues = {
            key: "AIzaSyBKgDGIW2OgOvTNaeHxS7ezHG96HGPYcZA",
            isPremium: false
        };
        newValues.settings.mapsApiKey = defaultMapsApiValues.key;
        newValues.settings.mapsIsPremium = defaultMapsApiValues.isPremium;
        newValues.searchBanner = Object.assign(newValues.searchBanner, careerSiteData);
        var bannerImagePath = newValues.searchBanner.bannerImagePath || "";
        newValues.searchBanner.bannerImagePath = [bannerImagePath];
        newValues.companyInformationHtml = careerSiteData.customBodyHtml;
        return newValues;
    };
    return CareerSiteHeaderFooterDataProvider;
}());
exports.CareerSiteHeaderFooterDataProvider = CareerSiteHeaderFooterDataProvider;



//////////////////
// WEBPACK FOOTER
// ../player-career-site-header-footer/shared/provider/CareerSiteHeaderFooterDataProvider.js
// module id = 228
// module chunks = 0 2